import { Component, Input } from '@angular/core';
import { BaseProject } from '../../../../../../../model/project/base-project';

@Component({
  selector: '[facturation-row]',
  templateUrl: './facturation-row.component.html',
  styleUrls: ['./facturation-row.component.scss'],
})
export class FacturationRowComponent {
  @Input()
  divergentPricesOnly: boolean;

  @Input()
  baseProject: BaseProject;

  @Input()
  description: string;

  @Input()
  price: number;

  @Input()
  distinctCompanyFactor: number;
}
